import Div from "@jumbo/shared/Div";
import {
    Typography,
    Box,
    Tab,
    Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    TabContext,
    TabList,
    TabPanel,
} from "@mui/lab";
import { BASE_URL } from "app/services/auth-services";
import axios from "axios";
import useResponsive from "app/pages/useResponsive";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import { FoyerCloseButton } from "app/shared/ReuseComponents/ButtonComponent";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";



const ViewApprovalLeaves = ({
    setListLeaves,
    setApprovalMaterial,
    overviewItems,
    dateFormat,
    scrollHeight
}) => {
    let userDetails = localStorage.getItem("UserDetails");
    userDetails = JSON.parse(userDetails);
    let companyId = userDetails && userDetails.Organization_Id;
    let id = userDetails && userDetails.id;
    let partnerId = parseInt(localStorage.getItem("PartnerId"));
    const token = localStorage.getItem("accesstoken");
    const header = {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    };


    const urlParams = new URLSearchParams(window.location.search);
    const Id = urlParams.get("Id");


    const [approvalStatus, setApprovalStatus] = useState([]);

    const [value, setValue] = useState("1");
    const [updateHistory, setUpdateHistory] = useState([]);


    const isMobile = useResponsive("between", "", "xs", "md");

    useEffect(() => {
        // for history
        axios
            .get(
                `${BASE_URL}/Felix/Updaterecordsfilter/?Partner_Id=${partnerId}&Document_Id=${overviewItems.Application_Id}`,
                header
            )
            .then((res) => {
                console.error("data", res.data);
                setUpdateHistory(res.data);
            })
            .catch((err) => {
                console.log("ds", err);
            });

        // fetch the approvers
        axios.get(`${BASE_URL}/Felix/Purchaserequestworkflow/?Request_Id=${overviewItems?.Application_Id}`)
            .then((res) => {
                console.log("REE", res.data);
                setApprovalStatus(res.data[0]?.Approve);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [overviewItems?.id]);


    // workflow
    const WorkflowName = "Leave";

    const handleClose = () => {
        setListLeaves(true);
        setApprovalMaterial(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <Div>
            <Typography variant="h3">
                Leave - Overview
            </Typography>

            <Div sx={{ mt: 2 }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab
                                label="Overview"
                                value="1"
                                sx={{ fontSize: "16px", color: "#000000" }}
                            />
                            {/* <Tab
                                label="History"
                                value="2"
                                sx={{ fontSize: "16px", color: "#000000" }}
                            /> */}
                        </TabList>
                    </Box>

                    <TabPanel value="1">
                        <Box>
                            <Grid container spacing={2}>
                                {/* Labels */}
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <Typography variant="h6" fontWeight={500}>Employee Name</Typography>
                                    <Typography variant="h6" fontWeight={500}>Leave Type</Typography>
                                    <Typography variant="h6" fontWeight={500}>From Date</Typography>
                                    <Typography variant="h6" fontWeight={500}>To Date</Typography>
                                    <Typography variant="h6" fontWeight={500}>Reason</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6} md={4} lg={0.3}>
                                    <Typography variant="h6" fontWeight={500}>:</Typography>
                                    <Typography variant="h6" fontWeight={500}>:</Typography>
                                    <Typography variant="h6" fontWeight={500}>:</Typography>
                                    <Typography variant="h6" fontWeight={500}>:</Typography>
                                    <Typography variant="h6" fontWeight={500}>:</Typography>
                                </Grid>


                                {/* Values */}
                                <Grid item xs={12} sm={6} md={6} lg={5.5}>
                                    <Typography variant="h6">
                                        {overviewItems?.Employee_Id?.Employee_FirstName} {overviewItems?.Employee_Id?.Employee_LasttName || "-"}
                                    </Typography>
                                    <Typography variant="h6">
                                        <DateFormatter date={overviewItems?.From_Date} />
                                    </Typography>
                                    <Typography variant="h6">
                                        <DateFormatter date={overviewItems?.To_Date} />
                                    </Typography>
                                    <Typography variant="h6">
                                        {overviewItems?.Leavetype || "-"}
                                    </Typography>
                                    <Typography variant="h6">
                                        {overviewItems?.ReasonOf_Leave || "-"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={12} lg={1}></Grid>

                                {/* Status Image */}
                                <Grid item xs={12} sm={12} md={12} lg={2} sx={{ display: 'flex', alignItems: 'start', justifyContent: { xs: 'flex-start', lg: 'center' } }}>
                                    {overviewItems?.Approved_Flag === true && overviewItems?.Status === true ? (
                                        <img src="/images/StatusFlg/Approved.png" width={160} height={80} alt="Approved" />
                                    ) : overviewItems?.Approved_Flag === false && overviewItems?.Status === true ? (
                                        <img src="/images/StatusFlg/Rejected.png" width={160} height={80} alt="Rejected" />
                                    ) : (
                                        <img src="/images/StatusFlg/Pending.png" width={160} height={80} alt="Pending" />
                                    )}
                                </Grid>
                            </Grid>
                        </Box>

                        <br />

                        <WorkflowApproverStatus WorkflowName={WorkflowName} approvalStatus={approvalStatus} partnerId={partnerId} />

                    </TabPanel>

                    <TabPanel value="2">
                        <HistoryOverview updatedHistory={updateHistory} itemId={"Leave No"} />
                    </TabPanel>
                </TabContext>
            </Div>

            <Div className="buttons" sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
                <FoyerCloseButton onClick={handleClose} />
            </Div>
        </Div>
    )
}

export default ViewApprovalLeaves